/*
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
 */
export default {
  'zh-CN': {
    dataExplain: '提示：共{m}条数据，问题数据{n}条，你可以返回修改后重新上传，或者先导入正确数据。',
    loadMore: '点击加载更多数据>',
    backList: '返回列表',
    uploadData: '上传数据',
    verifyImport: '校验导入数据',
    finish: '完成',
    nextStep: '下一步',
    importCorrentData: '导入正确数据',
    downloadIncorrectData: '下载问题数据',
    lastStep: '上一步',
    importExcel: '请导入表格文件',
    uploadSuccess: '上传成功',
    selImportMode: '选择导入方式',
    importLaterTip: '导入成功，{sec}秒后自动为您关闭!',
    downFileBtn: '下载数据文件',
    importNumTip: '导入成功{successCount}条，失败{failCount}条。',
    close: '关闭'
  },
  'en': {
    dataExplain: 'Prompt: {m}pieces of data in total. {n}pieces of problem data. You can go back to modify and reupload, or import the correct data first.',
    loadMore: 'Click to load more data>',
    backList: 'Back to list',
    uploadData: 'Upload data',
    verifyImport: 'Verify and import the data',
    finish: 'Finished',
    nextStep: 'Next',
    importCorrentData: 'Import Correct Data',
    downloadIncorrectData: 'Download problem data',
    lastStep: 'Previous step',
    importExcel: 'Please import the form file',
    uploadSuccess: '上传成功',
    selImportMode: '选择导入方式',
    importLaterTip: 'Import succeeded! Auto-close in {sec}seconds!',
    downFileBtn: 'Download data files',
    importNumTip: '{successCount}pieces import succeeded. {failCount}pieces import failed.',
    close: '关闭'
  },
  'jp': {
  }
}
